import { render, staticRenderFns } from "./JobSearchCard.vue?vue&type=template&id=3815b5d6&scoped=true&"
import script from "./JobSearchCard.vue?vue&type=script&lang=js&"
export * from "./JobSearchCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3815b5d6",
  null
  
)

export default component.exports